export default "__VITE_ASSET__DcEA14$N__"